import { create } from 'zustand';

import { initialConstants } from './application-navigation-store.config';
import { ApplicationNavigationStore } from './application-navigation-store.types';

/**
 * Сторка для навигации в разделе заявки.
 */
export const useApplicationNavigationStore = create<ApplicationNavigationStore>((set) => ({
	...initialConstants,
	setApplicationId: (applicationId) => set({ applicationId }),
	setApplicationType: (applicationType) => set({ applicationType }),
	setApplicationStatus: (applicationStatus) => set({ applicationStatus }),
	setStartPage: (startPage) => {
		if (startPage) set({ startPage });
	},
	cleanup: () => set({ ...initialConstants }),
}));
